import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Logo from './Logo';
import { company, pdfFlowsUrl } from '../data/site';

const groups = [
  {
    title: 'Company',
    links: [
      { label: 'About', to: '/#company' },
      { label: 'Products', to: '/#products' },
      { label: 'Contact', to: '/#contact' },
    ],
  },
  {
    title: 'Products',
    links: [
      { label: 'PDF Flows', to: '/pdf-flows' },
      { label: 'pdf-flows.com', href: pdfFlowsUrl },
      { label: 'InstruKit · Coming soon', to: '/instrukit' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Terms of Use', to: '/terms' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-ink text-white">
      <div className="container-x grid gap-12 py-16 lg:grid-cols-[1.2fr_2fr]">
        <div className="space-y-6">
          <Logo inverted />
          <p className="max-w-sm text-sm leading-relaxed text-white/60">
            Focused, privacy-first software for everyday work.
          </p>
          <address className="space-y-0.5 text-sm not-italic text-white/60">
            <span className="block font-medium text-white">{company.legalName}</span>
            {company.addressLines.map((l) => (
              <span key={l} className="block">{l}</span>
            ))}
            <a href={`mailto:${company.email}`} className="block pt-2 text-white/80 underline decoration-white/30 underline-offset-4 hover:decoration-white">
              {company.email}
            </a>
          </address>
        </div>

        <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
          {groups.map((g) => (
            <div key={g.title}>
              <h4 className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-white/45">{g.title}</h4>
              <ul className="mt-5 space-y-3">
                {g.links.map((l) => (
                  <li key={l.label}>
                    {l.href ? (
                      <a href={l.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-sm text-white/75 transition hover:text-white">
                        {l.label} <ArrowUpRight className="size-3.5" aria-hidden="true" />
                      </a>
                    ) : (
                      <Link to={l.to} className="text-sm text-white/75 transition hover:text-white">
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-col justify-between gap-2 py-6 text-xs text-white/45 sm:flex-row">
          <p>&copy; {new Date().getFullYear()} {company.legalName}. All rights reserved.</p>
          <p>{company.address}</p>
        </div>
      </div>
    </footer>
  );
}
